import { createStyles, getStylesRef, getSize, rem } from '@mantine/styles';
import { THUMB_SIZES } from '../Thumb/Thumb.styles.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var useStyles = createStyles((theme, _params, { size }) => ({
  sliderThumb: {
    ref: getStylesRef("sliderThumb")
  },
  slider: {
    position: "relative",
    height: `calc(${getSize({ size, sizes: THUMB_SIZES })} + ${rem(2)})`,
    boxSizing: "border-box",
    marginLeft: `calc(${getSize({ size, sizes: THUMB_SIZES })} / 2)`,
    marginRight: `calc(${getSize({ size, sizes: THUMB_SIZES })} / 2)`,
    outline: 0,
    [`&:focus .${getStylesRef("sliderThumb")}`]: __spreadValues({}, theme.focusRing === "always" || theme.focusRing === "auto" ? theme.focusRingStyles.styles(theme) : theme.focusRingStyles.resetStyles(theme)),
    [`&:focus:not(:focus-visible) .${getStylesRef("sliderThumb")}`]: __spreadValues({}, theme.focusRing === "auto" || theme.focusRing === "never" ? theme.focusRingStyles.resetStyles(theme) : null)
  },
  sliderOverlay: {
    position: "absolute",
    boxSizing: "border-box",
    top: 0,
    bottom: 0,
    left: `calc(${getSize({ size, sizes: THUMB_SIZES })} * -1 / 2 - ${rem(1)})`,
    right: `calc(${getSize({ size, sizes: THUMB_SIZES })} * -1 / 2 - ${rem(1)})`,
    borderRadius: 1e3
  }
}));

export default useStyles;
//# sourceMappingURL=ColorSlider.styles.js.map
